import { Image } from '../Image/Image';
import { MarkdownParagraph } from './MarkdownParagraph';
import { IMarkdownRenderers } from './IMarkdownRenderers';
import { MarkdownAnchor } from './MarkdownAnchor';

export const defaultMarkdownRenderers: IMarkdownRenderers = {
	p: MarkdownParagraph,
	img: Image,
	a: MarkdownAnchor,
};
